import {RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';

import {SUPPORTED_REQUIRED_LINK_FOLDER_ITEM_TYPES} from './SchemaFieldConstants';

export default function getFeatureStatusAwareRequiredLinkFolderItemTypes(): Array<string> {
  const excludedFolderItemTypes: Array<string> = [];
  if (!isFeatureEnabled({feature: RegistryFeature.REGISTRY_MIXTURES})) {
    excludedFolderItemTypes.push(ModelTypeConstants.MIXTURE);
  }
  if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE) {
    excludedFolderItemTypes.push(ModelTypeConstants.MOLECULE);
  }
  return SUPPORTED_REQUIRED_LINK_FOLDER_ITEM_TYPES.filter(
    (folderItemType) => !excludedFolderItemTypes.includes(folderItemType)
  );
}
